import { createSelector } from 'reselect'
import { get, isEmpty, uniqBy, makeSlug, formatCurrency } from '../../utils';

export const getModelLines = (state) => {
  const models = get(state, 'modellines.models') || [];
  return models.map(model => ({
    ...model,
    slug: makeSlug(model.modelLineFullName),
    bodySlug: makeSlug(model.bodyStyle)
  }));
}

export const getUniqueBodyStyles = createSelector(
  getModelLines,
  (modelLines) => {
    const bodyStyles = modelLines.map(model => ({
      name: model.bodyStyle,
      slug: makeSlug(model.bodyStyle),
    }));
    const uniqBodyStyles = uniqBy(bodyStyles, 'name');
    return uniqBodyStyles;
  }
)

export const getVehicleByModelLineCode = (state, modelLineCode) =>
  getModelLines(state).find(model => model.modelLineCode === modelLineCode);

export const getModelLineCodeBySlug = (state, slug) => {
  const models = getModelLines(state);
  if (isEmpty(models) || !slug) {
    return undefined;
  }
  const model = models.find(m => m.slug === slug);
  return model.modelLineCode;
}

export const getModelLineBySlug = (state, slug) => {
  const models = getModelLines(state);
  if (isEmpty(models) || !slug) {
    return undefined;
  }

  const slugValue = makeSlug(slug);
  const modelByName = models.find(model => model.slug === slugValue);
  const modelByModelLineCode = models
    .find(model => model.modelLineCode === slug.toUpperCase());
  const modelLine = modelByName || modelByModelLineCode;
  return modelLine
}

/**
 * needed to filter models by the bodystyle slug, was
 * previously comparing to the name of the vehicle.
 * @param state
 * @param bodyStyle
 * @returns {Array}
 */
const getBodyStyleBySlug = (state, bodyStyle) => {
  const models = getModelLines(state);
  const slugValue = makeSlug(bodyStyle);
  const selectedModels = [];
  for (let x = 0, y = models.length; x < y; x++) { //eslint-disable-line
    if (models[x].bodySlug === slugValue) selectedModels.push(models[x]);
  }
  return selectedModels;
};

export const getVehiclesByBodyStyleName = (state, name) => {
  const slug = makeSlug(name);
  const modelLines = getBodyStyleBySlug(state, slug);
  return modelLines.map(model => ({
    slug: makeSlug(model.bodyStyle),
    modelLineCode: model.modelLineCode,
    year: model.year,
    name: model.modelLineSEO,
    startingPrice: formatCurrency(model.minPrice),
    displayYear: model.displayYear
  }));
}

export const getActiveModel = (state) => {
  const models = getModelLines(state);
  const activeModelLineCode = state.navigation.modelLineCode;
  return models.find(model => model.modelLineCode === activeModelLineCode);
}

export const getActiveModelLineYear = (state) => {
  const activeModel = getActiveModel(state);
  if (!activeModel) {
    return undefined;
  }
  return activeModel.displayYear ? activeModel.displayYear : activeModel.year;
}

export const getActiveModelLineName = (state) => {
  const activeModel = getActiveModel(state);
  if (!activeModel) {
    return undefined;
  }
  return activeModel.modelLineSEO;
}

export const getActiveModelLineTrims = (state) => {
  const allTrims = state.trims.trims;
  const activeModelLineCode = state.navigation.modelLineCode;
  const activeTrims = allTrims[activeModelLineCode];
  return activeTrims
}

export const getActiveModelLineFullName = (state) => {
  const activeModel = getActiveModel(state);
  if (!activeModel) {
    return undefined;
  }
  return activeModel.modelLineFullName;
}



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/models.js
 **/